import { ConfigType } from 'src/withConfig';
import { SelectionPriceType } from './HomePageCarouselPromos.style';

export function getSelectionPromoBgColor(
    theme: ConfigType,
    { selectionPromoVariant, isSelected, isSuspended }: SelectionPriceType
): string {
    if (selectionPromoVariant) {
        if (isSuspended === true) {
            return theme.star.selection.bgColorSenary;
        }

        if (isSelected === true) {
            return theme.star.selection.bgColor;
        }

        return theme.star.selection.bgColorQuaternary;
    }

    if (isSuspended === true) {
        return theme.star.selection.bgColorSenary;
    }

    if (isSelected === true) {
        return theme.star.selection.bgColorQuinary;
    }

    return theme.star.selection.bgColor;
}

export function getSelectionPromoTextColor(
    theme: ConfigType,
    { selectionPromoVariant, isSelected, isSuspended }: SelectionPriceType
): string {
    if (selectionPromoVariant) {
        if (isSuspended === true) {
            return theme.star.selection.txtColorSecondary;
        }

        if (isSelected === true) {
            return theme.star.selection.bgColorTertiary;
        }

        return theme.star.selection.txtColorTertiary;
    }

    if (isSuspended === true) {
        return theme.star.selection.txtColorSecondary;
    }

    if (isSelected === true) {
        return theme.star.selection.txtColorTertiary;
    }

    return theme.star.selection.txtColor;
}
